module.exports = __webpack_public_path__ + "img/Weapon_232.28dfa819.png";